(function(){
  "use strict";

  angular
    .module("modules.trustHtml", [])
  ;

})();
